import { ReconciliationReportWithStatus } from 'pages/ReconciliationReportPage/types';

export const reconciliationReportData = [
  {
    vendorId: 'T70463',
    payableId: 'VCC0718',
    documentId: '9482',
    createdBy: 'bharathi',
    createdAt: '2021-12-20T15:16:03.805+00:00',
    updatedBy: 'bharathi',
    updatedAt: '2021-12-20T15:16:03.805+00:00',
    cardNumber: '4362',
    paymentDate: '2021-12-19T18:30:00.000+00:00',
    paymentAmount: 3400.0,
    settledAmount: 120.0,
    settledDate: '2021-12-21T18:30:00.000+00:00',
    transactionDate: '2021-12-19T18:30:00.000+00:00',
    transactionNumber: 'ss7',
    status: 'Reconciled',
    vendorName: 'Safeway'
  },
  {
    vendorId: 'T70463',
    payableId: 'VCC0715',
    documentId: '9182',
    createdBy: 'bharathi',
    createdAt: '2021-12-20T15:16:41.583+00:00',
    updatedBy: 'bharathi',
    updatedAt: '2021-12-20T15:16:41.583+00:00',
    cardNumber: '4862',
    paymentDate: '2021-12-19T18:30:00.000+00:00',
    paymentAmount: 3500.0,
    settledAmount: 3500.0,
    settledDate: '2021-12-21T18:30:00.000+00:00',
    transactionDate: '2021-12-19T18:30:00.000+00:00',
    transactionNumber: 'ss7',
    status: 'Reconciled',
    vendorName: 'Panda Express'
  },
  {
    vendorId: 'T70463',
    payableId: 'V00000232',
    documentId: '9482',
    createdBy: 'bharathi',
    createdAt: '2021-12-20T15:16:03.805+00:00',
    updatedBy: 'bharathi',
    updatedAt: '2021-12-20T15:16:03.805+00:00',
    cardNumber: '4362',
    paymentDate: '2021-12-19T18:30:00.000+00:00',
    paymentAmount: 1400.0,
    settledAmount: 1400.0,
    settledDate: '2021-12-19T18:30:00.000+00:00',
    transactionDate: '2021-12-19T18:30:00.000+00:00',
    transactionNumber: 'ss7',
    status: 'Pending',
    vendorName: 'Google'
  },
  {
    vendorId: 'T70463',
    payableId: 'V00000231',
    documentId: '9482',
    createdBy: 'bharathi',
    createdAt: '2021-12-20T15:16:03.805+00:00',
    updatedBy: 'bharathi',
    updatedAt: '2021-12-20T15:16:03.805+00:00',
    cardNumber: '4362',
    paymentDate: '2021-12-19T18:30:00.000+00:00',
    paymentAmount: 1500.0,
    settledAmount: 1500.0,
    settledDate: '2021-12-16T18:30:00.000+00:00',
    transactionDate: '2021-12-19T18:30:00.000+00:00',
    transactionNumber: 'ss7',
    status: 'Pending',
    vendorName: 'Safeway'
  },
  {
    vendorId: 'T70463',
    payableId: 'V00000231',
    documentId: '9482',
    createdBy: 'bharathi',
    createdAt: '2021-12-20T15:16:03.805+00:00',
    updatedBy: 'bharathi',
    updatedAt: '2021-12-20T15:16:03.805+00:00',
    cardNumber: '4362',
    paymentDate: '2021-12-19T18:30:00.000+00:00',
    paymentAmount: 100.0,
    settledAmount: 100.0,
    settledDate: '2021-12-18T18:30:00.000+00:00',
    transactionDate: '2021-12-19T18:30:00.000+00:00',
    transactionNumber: 'ss7',
    status: 'Voided',
    vendorName: 'Safeway'
  },
  {
    vendorId: 'T70463',
    payableId: 'V00000231',
    documentId: '9482',
    createdBy: 'bharathi',
    createdAt: '2021-12-20T15:16:03.805+00:00',
    updatedBy: 'bharathi',
    updatedAt: '2021-12-20T15:16:03.805+00:00',
    cardNumber: '4362',
    paymentDate: '2021-12-19T18:30:00.000+00:00',
    paymentAmount: 100.0,
    settledAmount: 100.0,
    settledDate: '2021-12-17T18:30:00.000+00:00',
    transactionDate: '2021-12-19T18:30:00.000+00:00',
    transactionNumber: 'ss7',
    status: 'Voided',
    vendorName: 'Safeway'
  }
];

export const reconciliationPaymentStatusUpdateResponse = {
  payableIds: [
    {
      payableId: '',
      remittanceNumber: '',
      changeStatusTo: ''
    }
  ],
  errorList: [
    'VCC0718',
    'VCC0719',
    'VCC0710',
    'VCC0711',
    'VCC0713',
    'VCC0712',
    'VCC0715',
    'VCC0716',
    'VCC0720',
    'VCC0721',
    'VCC0722',
    'VCC0723',
    'VCC0724',
    'VCC0725',
    'VCC0726'
  ]
};

export const reconciliationPaymentStatusUpdatePayload = [
  {
    payableId: '20',
    vendorNo: '143',
    settledAmount: 12,
    settledDate: '11-22-2022',
    transactionDate: '11-23-2022',
    transactionNumber: 'ss7',
    changeStatusTo: 'Pending'
  }
];

export const reconciliationReportWithPaymentStatus = (
  statuses: string
): ReconciliationReportWithStatus[] =>
  reconciliationReportData.filter(data => statuses.includes(data.status));
